import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom"; 
import { jwtDecode } from "jwt-decode";
import SidebarBuyer from "../../Requirement/components/layout/BuyerSidebarnew";
import Header from '../../Requirement/components/layout/Header';
import { useLoading } from '../../../context/LoadingContext';

import "../../../styles/requirement.css";
import "../../../styles/general.css";
import "../../../styles/buyer.css";

const Communication = () => {
    const [activeUser, setActiveUser] = useState("");
    const [activeTab, setActiveTab] = useState("");
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const tabs = ["Chat with Sellers", "Broadcast Message","Contact Support"];

    useEffect(() => {
        const checkUser = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const token = user.signInUserSession.idToken.jwtToken;
                const decodedToken = jwtDecode(token);
                const groups = decodedToken["cognito:groups"] || [];
                if (!groups.includes("AMTPL_BUYERS")) {
                    await Auth.signOut();
                    navigate("/login/buyer");
                } else {
                    setActiveUser(user.attributes.email);
                }
            } catch (error) {
                await Auth.signOut();
                navigate("/login/buyer");
            }
        };
        checkUser();
    }, [navigate]);

    const renderTabContent = () => {
        switch (activeTab) {
            
            default:
                
        }
    };

    return (
        <div className="buyer-layout">
            
            <div className="amtpl-tabs">
                

                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Communication;